module.exports = __webpack_public_path__ + "static/media/envato.28fa77b7.svg";